import logService from '../../../../services/wss/logService3';

const _name = 'OnSelectedEntryHandler';

/**
 * Handles EngineEvents.onSelectedEntry.
 * Updates activeNodeId + activeEntryId on the group in cache and persists to BE.
 *
 * rk = group id
 * Payload: OnSelectedEntryData { rk, nid, eid }
 */
export default class OnSelectedEntryHandler {
    constructor(cache, saver) {
        this._cache = cache;
        this._saver = saver;
    }

    handle = async (data) => {
        try {
            this._cache.setActiveEntry(data);
            await this._saver.saveActiveEntry(data);
        } catch (error) {
            logService.logError(`${_name}.handle: ${error.message}`);
        }
    };
}
